import customersServiceGen from "./generated/customersServiceGen";
import { getCore as get } from "../../utils/httpInterceptor";

class customersService extends customersServiceGen {
  // Exact-match lookup by primary key (dataAreaId + accountNum). The generic
  // getAll/list "accountNum" filter is a case-insensitive *contains* match
  // (LegacySpecificationBuilder applies LIKE %value%), so searching "199"
  // also returns "4199", "1995", etc. This hits the single-record findById
  // endpoint instead: exact, no pagination, one request.
  static async getByAccountNum(dataAreaId, accountNum) {
    const normalizedDataAreaId = (dataAreaId || "").trim();
    const normalizedAccountNum = (accountNum || "").trim();
    if (!normalizedDataAreaId || !normalizedAccountNum) {
      return null;
    }
    try {
      return await get(
        `${customersServiceGen.getApiPath("customers")}/${encodeURIComponent(normalizedDataAreaId)}/${encodeURIComponent(normalizedAccountNum)}`,
      );
    } catch (error) {
      if (error?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  // Resolves the exact customer for an account number, regardless of
  // whether dataAreaId is known yet (e.g. while creating a brand new order
  // before it has a dataAreaId in the URL). Prefers the exact findById
  // lookup when dataAreaId is available (one request); otherwise paginates
  // the "contains" search and filters for an exact accountNum match, since
  // the generic filter alone could match the wrong account (e.g. "199"
  // matching "4199").
  static async findExactByAccountNum(accountNum, dataAreaId) {
    const normalizedAccountNum = (accountNum || "").trim();
    if (!normalizedAccountNum) {
      return null;
    }

    if (dataAreaId) {
      const exactMatch = await customersService.getByAccountNum(dataAreaId, normalizedAccountNum);
      if (exactMatch) {
        return exactMatch;
      }
    }

    const upperAccountNum = normalizedAccountNum.toUpperCase();
    let pageIndex = 0;
    const maxPages = 10;
    const pageSize = 100;
    while (pageIndex < maxPages) {
      const page = await customersServiceGen.getAll(pageIndex, pageSize, [], {
        accountNum: normalizedAccountNum,
      });
      const rows = Array.isArray(page?.content) ? page.content : [];
      const match = rows.find(
        (row) => String(row?.accountNum ?? row?.accountnum ?? "").trim().toUpperCase() === upperAccountNum,
      );
      if (match) {
        return match;
      }
      const totalPages = Number(page?.totalPages) || 1;
      pageIndex += 1;
      if (pageIndex >= totalPages) {
        break;
      }
    }
    return null;
  }
}

export default customersService;